import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const InfoModal = ({ isOpen, onClose, folderDetails, onRename }) => {
  const { user } = useAuth();
  
  const [newFolderName, setNewFolderName] = useState(folderDetails?.entity_name || "");

  const handleRename = () => {
    //if (newFolderName.trim()) {
      onRename(newFolderName,folderDetails);
    //}
  };

  return (
    <div className={`modal fade infomodal ${isOpen ? "show d-block" : ""}`} id="infoModal" tabIndex="-1" role="dialog" style={{ background: "rgba(0, 0, 0, 0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{folderDetails?.entity_name || "Folder Name"}</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="info_body">
              <div className="row">
                <div className="col-6">
                  <label>Size:</label> {folderDetails?.folder_size || "N/A"}
                </div>
                <div className="col-6">
                  
                  <label>Assigned To:</label> 
                  <ul>
                  {folderDetails?.assigned_users?.length > 0
                    ? folderDetails.assigned_users.map((user, index) => (
                      <li className="usr-list">
                        {user.user_name} <br />
                      </li>
                    ))
                    : "Unassigned"}
                    </ul>
                </div>
                <div className="col-12">
                  <label>Rename Folder</label>
                  <div className="rename_holder">
                    <input
                      type="text"
                      value={newFolderName}
                      onChange={(e) => setNewFolderName(e.target.value)}
                      readOnly={user?.user_role === "CLIENT"}
                    />
                     {user?.user_role?.toLowerCase()!== "client" && (
                    <button type="button" className="btn btn-primary" onClick={handleRename} >
                      Save
                    </button>
                     )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
